import { useContactUs } from "@/hooks/main-hook";
import { ContactFormProps } from "@/types/main-types";
import { useTranslations } from "next-intl";
import { useForm } from "react-hook-form";

export default function ContactForm() {
  const t = useTranslations("Contact");

  const { mutate, isPending } = useContactUs();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ContactFormProps>({ mode: "all" });

  const handleSendMsg = (data: ContactFormProps) => {
    mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };

  return (
    <div className="mt-18 pb-14">
      <h3 className="text-3xl font-extrabold text-main">{t("sendMsg")}</h3>
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="lg:w-1/2">
          <form
            onSubmit={handleSubmit(handleSendMsg)}
            className="flex flex-col gap-6 mt-8 "
          >
            <input
              type="text"
              placeholder={t("name")}
              {...register("name", { required: true })}
              className={`border p-3 rounded-md outline-none focus:border-main  ${
                errors.name ? "border-red-500" : "border-gray-300"
              }`}
            />
            <input
              type="email"
              placeholder={t("email")}
              {...register("email", { required: true })}
              className={`border p-3 rounded-md outline-none focus:border-main ${
                errors.email ? "border-red-500" : "border-gray-300"
              }`}
            />
            <input
              type="text"
              placeholder={t("subject")}
              {...register("subject", { required: true })}
              className={`border p-3 rounded-md outline-none focus:border-main ${
                errors.subject ? "border-red-500" : "border-gray-300"
              }`}
            />
            <textarea
              placeholder={t("message")}
              rows={6}
              {...register("message", { required: true })}
              className={`border p-3 rounded-md outline-none focus:border-main ${
                errors.message ? "border-red-500" : "border-gray-300"
              }`}
            />
            <button
              disabled={isPending}
              type="submit"
              className="bg-main text-white py-3 rounded-md font-semibold hover:bg-main/90 transition duration-200 w-full disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
            >
              {t("send")}
            </button>
          </form>
        </div>
        <div className="lg:w-1/2 w-full h-100 lg:h-auto">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d237685.10574004662!2d39.68173814987756!3d21.435934766209062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c21b4ced818775%3A0x98ab2469cf70c9ce!2sMakkah%20Saudi%20Arabia!5e0!3m2!1sen!2seg!4v1768064503786!5m2!1sen!2seg"
            width="100%"
            height="100%"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-xl"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
